export default __webpack_public_path__ + "static/media/downInActive.d9abb9fa.svg";